import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { ConcurrentRequestsInterceptorService } from './concurrent-requests-interceptor.service';
import { CoreHttpModuleConfig } from './core-http-module-config.interface';
import { InterceptorService } from './interceptor.service';
import { OktaInterceptorService } from './okta-interceptor.service';
import { PasInterceptorService } from './pas-interceptor.service';

@NgModule({
	declarations: [],
	// eslint-disable-next-line
	imports: [
		HttpClientModule,
		HttpClientXsrfModule.withOptions({
			cookieName: 'NAUTILUS-XSRF-TOKEN',
			headerName: 'X-NAUTILUS-XSRF-TOKEN'
		})
	]
})
export class CoreHttpModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreHttpModule) {
		if (parentModule) {
			const moduleName = parentModule.constructor.name;
			throw new Error(`${moduleName} has already been loaded. Import ${moduleName} module in the AppModule only.`);
		}
	}

	/**
	 * Always use .forRoot() so that base interceptors are added
	 */
	public static forRoot(config: CoreHttpModuleConfig = { interceptors: [] } as CoreHttpModuleConfig): ModuleWithProviders<CoreHttpModule> {
		return {
			ngModule: CoreHttpModule,
			providers: [
				...config.interceptors,

				// base interceptor service for all apps
				{
					provide: HTTP_INTERCEPTORS,
					useClass: OktaInterceptorService,
					multi: true
				},
				{
					provide: HTTP_INTERCEPTORS,
					useClass: ConcurrentRequestsInterceptorService,
					multi: true
				},
				{
					provide: HTTP_INTERCEPTORS,
					useClass: PasInterceptorService,
					multi: true
				},
				{
					provide: HTTP_INTERCEPTORS,
					useClass: InterceptorService,
					multi: true
				}
			]
		};
	}
}
